// extracted by mini-css-extract-plugin
export default {"cls1":"News-cls1___99f64a345d9d6a8e41c","cls2":"News-cls2__eecd5d19affbc484cac8 News-cls1___99f64a345d9d6a8e41c"};